export default "__VITE_ASSET__D74QsG$x__"